import { isMobileApp, isNewIOSApp } from '@airtel-lego/native-app-bridge';

export const fetchUserLocation = (): Promise<object> => {
   return new Promise((resolve) => {
      (async () => {
         if (isMobileApp()) {
            const callback = (locationData: any) => {
               if (typeof locationData === 'string') {
                  locationData = JSON.parse(locationData);
               }

               resolve({
                  latitude: locationData?.Lat || locationData?.lat,
                  longitude: locationData?.Lon || locationData?.lon,
                  error: locationData?.Error || locationData?.error,
               });
            };

            if (isNewIOSApp()) {
               if (window.app) {
                  window.app['fetchCurrentLocationCallback'] = callback;
               } else {
                  window.app = {
                     fetchCurrentLocationCallback: callback,
                  };
               }
               window.webkit?.messageHandlers?.triggerAppEvent?.postMessage?.({
                  eventName: 'fetchCurrentLocation',
                  callback: 'fetchCurrentLocationCallback',
               });
            } else {
               if (window.MyAirtelAppReact?.fetchCurrentLocation) {
                  window['fetchCurrentLocationCallback'] = callback;
                  window.MyAirtelAppReact?.fetchCurrentLocation(
                     'fetchCurrentLocationCallback'
                  );
               }
            }
         } else {
            resolve({});
         }
      })();
   });
};

export const requestLocationPermission = (locationPermissionCallback: Function) => {
   if (isNewIOSApp()) {
      const permissionObj = {
         permissions: [
            {
               type: 'Location When Use',
               title: 'Location access needed',
               subtitle: 'This is required to complete your digital KYC process.',
               imageURL:
                  'https://assets.airtel.in/static-assets/acq-skyc/lcoation-permission.png',
            },
         ],
         maxIterations: 999,
         callback: 'locationPermissionCallback',
         journeyName: 'skyc_reverification',
         prePermissionPopupEnabled: true,
         postPermissionPopupFrequency: 'always',
         extraData: {
            buttonColor: '#D73737',
            backgroundColor: '#F3F4F7',
            closeButtonBackgroundColor: '#DADFE7',
            callbackAfterSetting: true,
         },
      };

      window.webkit?.messageHandlers?.requestPermissionsWithContext?.postMessage?.(
         JSON.stringify(permissionObj)
      );
      window.app = {
         locationPermissionCallback,
      };
   } else {
      const permissionObj = {
         'android.permission.ACCESS_FINE_LOCATION': {
            title: 'Location access needed',
            desc: 'This is required to complete your digital KYC process.',
            iconUrl:
               'https://assets.airtel.in/static-assets/acq-skyc/lcoation-permission.png',
         },
      };

      window.locationPermissionCallback = locationPermissionCallback;

      window.MyAirtelAppReact?.requestPermissionsWithContext?.(
         JSON.stringify(permissionObj),
         JSON.stringify({}),
         'skyc_reverification',
         'locationPermissionCallback'
      );
   }
}

export const getLocationPermissionModalData = () => {
   const ua = navigator.userAgent;

   const isMacSafari = ua.includes("Macintosh") && ua.includes("Safari") && !ua.includes("Chrome");
   const isIosSafari = /iP(hone|ad|od)/.test(ua) && ua.includes("Safari") && !ua.includes("CriOS");
   const isMacChrome = ua.includes("Macintosh") && ua.includes("Chrome");
   const isIosChrome = /iP(hone|ad|od)/.test(ua) && ua.includes("CriOS");
   const isAndroidChrome = ua.includes("Android") && ua.includes("Chrome");

   const stepOpenSettings = {
      subTitle: "Open your device Settings",
      iconUrl: isAndroidChrome ? "https://assets.airtel.in/static-assets/acq-skyc/android-settings-icon.png" : "https://assets.airtel.in/static-assets/acq-skyc/settings-icon.png"
   };

   const stepPrivacy = {
      subTitle: "Navigate to Privacy & Security",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/navigation-icon.png"
   };

   const stepLocation = {
      subTitle: "Location service (ensure Location is ON)",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/location-service-icon.png"
   };

   const stepAppPerm = {
      subTitle: "Go to App permissions",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/android-icon.png"
   };

   const stepScrollSafari = {
      subTitle: "Scroll to Safari",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/safari-icon.png"
   };

   const stepScrollChrome = {
      subTitle: "Scroll to Chrome",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/chrome-icon.png"
   };

   const stepSwitch = {
      subTitle: 'Set it to "While Using the App" or "Always"',
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/switch-icon.png"
   };

   const stepRefresh = {
      subTitle: "Refresh the page",
      iconUrl: "https://assets.airtel.in/static-assets/acq-skyc/refresh-icon.png"
   };

   function getData() {
      if (isAndroidChrome) {
         return [
            stepOpenSettings,
            stepLocation,
            stepAppPerm,
            stepScrollChrome,
            stepSwitch,
            stepRefresh
         ];
      }

      const baseAppleFlow = [
         stepOpenSettings,
         stepPrivacy,
         stepLocation
      ];

      if (isMacSafari || isIosSafari) {
         return [
            ...baseAppleFlow,
            stepScrollSafari,
            stepSwitch,
            stepRefresh
         ];
      }

      if (isMacChrome || isIosChrome) {
         return [
            ...baseAppleFlow,
            stepScrollChrome,
            stepSwitch,
            stepRefresh
         ];
      }

      return [
         stepOpenSettings,
         stepLocation,
         stepSwitch,
         stepRefresh
      ];
   }
   const data = getData();
   return data;
}
